module.exports = __webpack_public_path__ + "static/media/product-2.eae0fa3c.png";